export default __webpack_public_path__ + "static/media/Wechselpilot.67bed54c.jpg";